import * as numberInput from '@zag-js/number-input';
import { normalizeProps, useMachine } from 'zag-ripple';
import { track } from 'ripple';
import { ChevronUp, ChevronDown } from 'lucide-ripple';

export component NumberInput() {
	let service = useMachine(numberInput.machine, {
		id: 'number-input',
	});
	let api = track(() => numberInput.connect(service, normalizeProps));

	<div {...@api.getRootProps()}>
		<label {...@api.getLabelProps()}>{"Enter number:"}</label>
		<div>
			<input {...@api.getInputProps()} />
			<div>
				<button {...@api.getIncrementTriggerProps()}>
					<ChevronUp />
				</button>
				<button {...@api.getDecrementTriggerProps()}>
					<ChevronDown />
				</button>
			</div>
		</div>
	</div>
}
